
export default class FormSubmit {

    constructor() {
        this.settings = {
            button: document.querySelector('.gform_button')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.button != null) {

            this.settings.button.addEventListener('click', () => {

                const labels = document.querySelector('.js-required-labels');
                labels.classList.add('hidden');

            });
            
        }

    }

};

new FormSubmit();